'use client';

import SacolaDesktopFallback from '@/components/pages/Sacola/Designs/Desktop/fallback';
import SacolaMobile from '@/components/pages/Sacola/Designs/Mobile';
import useBreakpoint from '@/hooks/useBreakpoint';
import dynamic from 'next/dynamic';

const SacolaDesktop = dynamic(
  () => import('@/components/pages/Sacola/Designs/Desktop'),
  {
    ssr: false,
    loading: () => <SacolaDesktopFallback />,
  },
);

export default function Sacola() {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? <SacolaMobile /> : <SacolaDesktop />;
}
